// extracted by mini-css-extract-plugin
export default {"root":"P6k_Bp5s3NOYZc_NvppI"};